import { IonCard, IonCardHeader, IonCardTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { Machine } from '../../../api/graphql/generated';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';
import './card.css';
interface FilesCardProps {
  machine?: Machine;
}

const FilesCard = (props: FilesCardProps): ReactElement => {
  const { machine } = props;

  const { builder } = useBeaconRouter();

  return (
    <IonCard
      className="machine-card-container"
      routerLink={
        machine
          ? builder.getMachineFilesRoute(machine.teamId, machine.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>{i18n.t('common:machine_files_desc')}</IonCardTitle>
      </IonCardHeader>
      <p className="card-description">
        {i18n.t('common:machine_files_description_for_card')}
      </p>
    </IonCard>
  );
};

export { FilesCard };
